import RoomEditor from "./RoomEditor";
import PropTypes from 'prop-types';
import EntityTable from "../../../../common/Tables/EntityTable";
import { PicturesIcon } from "../../../../common/icons/Icons";
import { useState } from "react";
import RoomsPicturesEditor from "./RoomPicturesEditor";

const RoomsList = ({ propertyId, rooms, onCreateRoom, onUpdateRoom, onDeleteRoom, deleteRoom, onError }) => {
    const [editedRoomPicturesId, setEditedRoomPicturesId] = useState(null);

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            disableColumnMenu: true,
            sortable: false,
            hide: true
        },
        {
            field: 'name',
            headerName: 'Name',
            minWidth: 150,
            flex: 1
        },
        {
            field: 'description',
            headerName: 'Description',
            minWidth: 300,
            flex: 2
        },
        {
            field: 'count',
            headerName: 'Units',
            type: 'number',
            width: 150,
            disableColumnMenu: true,
        },
        {
            field: 'maxOccupancy',
            headerName: 'Max occupancy',
            type: 'number',
            width: 150,
            disableColumnMenu: true
        }
    ];

    const openRoomPictures = (roomId) => {
        setEditedRoomPicturesId(roomId);
    }

    return <>
        <EntityTable
            data={rooms}
            columns={columns}
            dataGridProps={{
                disableSelectionOnClick: true
            }}
            enableCreateEntity
            enableEditEntity
            enableDeleteEntity
            onEntityCreateSuccess={onCreateRoom}
            onEntityUpdateSuccess={onUpdateRoom}
            onEntityDeleteSuccess={onDeleteRoom}
            deleteEntityAction={deleteRoom}
            EditorComponent={RoomEditorWrapper}
            editorProps={{
                propertyId: propertyId
            }}
            noEntitiesMessage="It looks like you haven't added any rooms yet"
            customGridActions={[
                {
                    id: 'room-pictures',
                    position: 15,
                    icon: (props) => <PicturesIcon title='Edit room pictures' {...props} />,
                    onClick: openRoomPictures,
                }
            ]}
            onError={onError}
        />
        {editedRoomPicturesId && <RoomsPicturesEditor propertyId={propertyId} roomId={editedRoomPicturesId} onClose={() => setEditedRoomPicturesId(null)} />}
    </>
}

const RoomEditorWrapper = ({ editedEntity, existingEntities, ...props }) => {
    return <RoomEditor editedRoom={editedEntity} existingRooms={existingEntities} {...props} />
}

RoomsList.propTypes = {
    propertyId: PropTypes.string.isRequired,
    rooms: PropTypes.array.isRequired,
    onRoomCreate: PropTypes.func,
    onRoomDelete: PropTypes.func,
}

export default RoomsList;